import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ModeloCard from './components/ModeloCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const ModelosMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Modelos de Veículos'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <ModeloCard />
        </Col>
      </Row>
    </Container>;
};

export default ModelosMain;
